import { GetAuditHistoryPayload } from "../models/viewAudit.model";
import axiosInstance from "../utils/api-util/utilApi"

const config = { baseURL: process.env.REACT_APP_TRANSACTION_SERVICE_URL || '' }

export const getAuditHistoryView = (payload: Partial<GetAuditHistoryPayload>) => {
  return axiosInstance.post('/transactionAudit/viewAudit', payload, config);
}

export const getUsersByAuditHistory = (id: string) => {
  return axiosInstance.get(`/transactionAudit/getAuditUsers/${id}`, config);
}